export default "__VITE_ASSET__C1woe5QY__"